import {slugifyString} from '@common/utils/string/slugify-string';
import {BlogHeading} from '@app/blog/use-public-blog';

export function prepareBlogArticleHtml(html: string): {
  html: string;
  headings: BlogHeading[];
} {
  if (!html) {
    return {html: '', headings: []};
  }

  if (typeof DOMParser === 'undefined') {
    return {html, headings: []};
  }

  const doc = new DOMParser().parseFromString(
    `<div>${html}</div>`,
    'text/html',
  );
  const container = doc.body.firstElementChild;
  if (!container) {
    return {html, headings: []};
  }

  const headings: BlogHeading[] = [];
  const usedIds = new Set<string>();

  container.querySelectorAll('h2').forEach(el => {
    const text = el.textContent?.trim();
    if (!text) {
      return;
    }

    let id = el.getAttribute('id')?.trim() ?? '';
    if (!id) {
      const base = slugifyString(text) || 'section';
      id = base;
      let suffix = 2;
      while (usedIds.has(id)) {
        id = `${base}-${suffix}`;
        suffix++;
      }
      el.setAttribute('id', id);
    }

    usedIds.add(id);
    headings.push({id, text});
  });

  return {html: container.innerHTML, headings};
}
